<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
    style="background-color: #ffffff !important"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start text-center">
        <a href="#">
          <img src="img/aavin/company_logo.png" class="img-fluid logo" />
        </a>
      </div>
      <div class="text-center">
        <h2 class="mt-2 logo-content text-center">
          Tamilnadu Co-operative Milk Producers' Federation Limited (TCMPF
          Ltd.,)
        </h2>
        <small class="text-secondary align-text-top text-center"
          >Aavin Illam, 3A, Pasumpon Muthuramalinganar Salai,Nandanam, Chennai -
          600 035,Tamil Nadu</small
        >
      </div>
      <div class="md-toolbar-section-end text-center">
        <a class="navbar-brand" href="#">
          <img src="img/aavin/img1.png" class="img-fluid logo" />
        </a>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
};
</script>
<style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}
.logo {
  width: 103px;
}
.logo-content {
  font-size: 22px;
  color: #474a98;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 1px;
}
.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:focus,
a.text-secondary:hover {
  color: #545b62 !important;
}
.align-text-top {
  vertical-align: text-top !important;
}
.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}
.text-center {
  text-align: center !important;
}
</style>
<style>
.md-toolbar-section-end,
.md-toolbar-section-start {
  display: block !important;
}
</style>